import { render } from "./TOS.vue?vue&type=template&id=4a8931dd&scoped=true"
const script = {}

import "./TOS.vue?vue&type=style&index=0&id=4a8931dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8931dd"]])

export default __exports__